import request from '@/utils/request'

// 获取账号列表数据层
export async function api_getTableList(params) {
  return request({
    url: '/rest/account/page',
    method: 'get',
    params,
  })
}

// 重置密码
export async function api_putResetPW(params) {
  return request({
    url: '/rest/account/reset',
    method: 'put',
    params,
  })
}

// 启停账号
export async function api_putChangeDisable(params) {
  return request({
    url: '/rest/account/toggle',
    method: 'put',
    params,
  })
}

// 获取权限配置list数据
export async function api_getPermissonList(params) {
  return request({
    url: '/rest/permission',
    method: 'get',
    params,
  })
}

// 获取账号详情数据
export async function api_getPermissonDetail(params) {
  return request({
    url: '/rest/account',
    method: 'get',
    loading: true,
    params,
  })
}

// 创建账号
export async function api_postPermissonAdd(data) {
  return request({
    url: '/rest/account',
    method: 'post',
    data,
  })
}

// 编辑账号
export async function api_putPermissonEdit(data) {
  return request({
    url: '/rest/account',
    method: 'put',
    data,
  })
}
